import { createContext } from 'react'
import type { AppInfoMessagePagedQuery } from '../dtos'
import type { IPaginationContext } from '../interfaces/Pagination/Pagination'

export const appInfoListContext = createContext<IPaginationContext<AppInfoMessagePagedQuery>>({} as IPaginationContext<AppInfoMessagePagedQuery>)